<template>
  <div class="guite-enquiries">
    <div class="wrapper">
      <div class="container">
        <div class="booking-intro">
          <div class="title">
            <img alt src="../../assets/img/hornor-buy/book-icon.png" />
            <span>预约成功</span>
          </div>
          <div class="desc">
            {{userNetwork.phone}}您好，您已经成功预约了
            <em>「{{userNetwork.title}}档信用购办理业务」</em>办理完成后将获得可得
            <em>{{userNetwork.award}}</em>
            。请您再{{userNetwork.start_time}} — {{userNetwork.end_time}}内，到以下网点现场办理。
          </div>
        </div>
        <div class="network-desc">
          <div class="title">
            <img alt src="../../assets/img/hornor-buy/store-iocn.png" />
            <span>办理网点地址</span>
          </div>
          <div class="intro">
            <div class="name">{{userNetwork.addr.title}}</div>
            <div class="address">地址: {{userNetwork.addr.addr}}</div>
            <div class="phone">联系电话: {{userNetwork.addr.tel}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userNetwork: {}
    }
  },
  created () {
    this.getUserNetWork()
  },
  methods: {
    async getUserNetWork () {
      const res = await this.$axios.get('api/business/addr')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.userNetwork = data
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.guite-enquiries {
  width: 100%;
  min-height: 13.34rem;
  background: url("../../assets/img/hornor-buy/hornor-banner.png") top no-repeat
    #e62717;
  background-size: 100% 9.84rem;
  .wrapper {
    padding-top: 8.54rem;
    padding-bottom: 0.4rem;
  }
  .container {
    margin: 0 0.3rem;
    background-color: #fff;
    border-radius: 8px;
    .booking-intro {
      .title {
        padding-top: 0.7rem;
        .flex-center;
        color: #1abc9c;
        font-size: 0.42rem;
        font-weight: bold;
        img {
          width: 0.91rem;
          height: 0.83rem;
          padding-right: 0.2rem;
        }
      }
      .desc {
        padding: 0.55rem 0.5rem;
        font-size: @fz24;
        color: @base;
        em {
          color: #fd8a39;
        }
      }
    }
  }
  .network-desc {
    width: 6.64rem;
    padding: 0.35rem 0;
    margin: 0 auto;
    font-size: @fz26;
    background-color: #fff;
    border-radius: 12px;
    color: #000;
    .title {
      font-size: @fz24;
      color: #fd8a39;
      position: relative;
      .flex-center;
      &::after,
      &::before {
        content: "";
        position: absolute;
        width: 1.5rem;
        height: 1px;
        background-color: #fd8a39;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        left: 0.3rem;
      }
      &::before {
        right: 0.3rem;
      }
      img {
        width: 0.33rem;
        height: 0.29rem;
        padding-right: 0.2rem;
      }
    }
    .intro {
      padding: 0.2rem 0 0.4rem;
      padding-left: 0.3rem;
    }
    .name {
      font-size: 0.24rem;
      font-weight: bold;
      color: @base;
    }
    .address {
      padding: 0.12rem 0;
    }
    .address,
    .phone {
      color: @c80;
    }
  }
}
</style>
